// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"0880f532","453":"a1f310ff"}[chunkId] + ".chunk.js";
};